export const baseUrlApi = process.env.REACT_APP_API_URL;
//export const apikey = process.env.REACT_APP_API_KEY;
